'use client';

import { TextStyledLink } from '@components/Common';
import {
  CheckboxWrapper,
  Container,
  CustomCheckbox,
  HiddenCheckbox,
  Text,
} from '@components/TermsCheckbox';
import { CheckboxWithLinkProps } from '@components/TermsCheckbox/interfaces';

/**
 * Checkbox with text and link component for terms and conditions.
 */
export const CheckboxWithLink = ({
  label,
  linkText,
  linkUrl,
  checked = false,
  onChange,
  id = 'terms-checkbox',
}: CheckboxWithLinkProps) => {

  return (
    <Container>
      <CheckboxWrapper>
        <HiddenCheckbox
          type="checkbox"
          id={id}
          checked={checked}
          onChange={() => onChange(!checked)}
          required
          name="terms"
        />
        <CustomCheckbox />
      </CheckboxWrapper>
      <Text htmlFor={id}>
        {label}
        <TextStyledLink href={linkUrl} target="_blank" rel="noopener noreferrer">
          {linkText}
        </TextStyledLink>
        .
      </Text>
    </Container>
  );
};
